
import PropTypes from 'prop-types';
import EditorActions from './EditorActions';
import ThemeToggle from './ThemeToggle';
import ZoomControls from './ZoomControls';
import FullscreenButton from './FullscreenButton';

function Header({ 
  theme, 
  onThemeChange, 
  onToggleSidebar, 
  sidebarVisible, 
  onSave, 
  onClear, 
  onExportSVG, 
  onCopy, 
  hasContent,
  // Zoom controls props
  onZoomIn,
  onZoomOut,
  onZoomFit,
  onZoomActual,
  zoomLevel,
  onToggleFullscreen,
  isFullscreen
}) {
  return (
    <header className="header">
      <div className="header__logo">
        <button
          className="btn btn--secondary btn--sm btn--icon"
          onClick={onToggleSidebar}
          title={sidebarVisible ? 'Hide sidebar' : 'Show sidebar'}
        >
          <span style={{ fontSize: 'var(--font-size-md)' }}>{sidebarVisible ? '☰' : '☰'}</span>
        </button>
        <h1 className="header__title">Mermaid Playground</h1>
      </div>
      
      {/* Actions Section */}
      <div className="header__actions">
        {/* Zoom Controls Group */}
        <ZoomControls
          onZoomIn={onZoomIn}
          onZoomOut={onZoomOut}
          onZoomFit={onZoomFit}
          onZoomActual={onZoomActual}
          zoomLevel={zoomLevel}
        />
        
        {/* Fullscreen Button */}
        <div className="fullscreen-btn">
          <FullscreenButton 
            onToggleFullscreen={onToggleFullscreen}
            isFullscreen={isFullscreen}
          />
        </div>
        
        {/* Editor Actions Group */}
        <EditorActions
          onSave={onSave}
          onClear={onClear}
          onExportSVG={onExportSVG}
          onCopy={onCopy}
          hasContent={hasContent}
        />
        
        {/* Theme Toggle */}
        <ThemeToggle theme={theme} onThemeChange={onThemeChange} />
      </div>
    </header>
  );
}

Header.propTypes = {
  theme: PropTypes.string.isRequired,
  onThemeChange: PropTypes.func.isRequired,
  onToggleSidebar: PropTypes.func.isRequired,
  sidebarVisible: PropTypes.bool.isRequired,
  onSave: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
  onExportSVG: PropTypes.func.isRequired,
  onCopy: PropTypes.func.isRequired,
  hasContent: PropTypes.bool.isRequired,
  // Zoom controls props
  onZoomIn: PropTypes.func.isRequired,
  onZoomOut: PropTypes.func.isRequired,
  onZoomFit: PropTypes.func.isRequired,
  onZoomActual: PropTypes.func.isRequired,
  zoomLevel: PropTypes.number.isRequired,
  onToggleFullscreen: PropTypes.func.isRequired,
  isFullscreen: PropTypes.bool.isRequired
};

export default Header;
